export function isTimeInBzHours(businessHours, timeZone) {
  const WeekDaysInOrder = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const signUpTime = new Date(Date.now()).toISOString();
  const signUpDateTime = new Date(signUpTime);
  const localtime = signUpDateTime.toLocaleDateString("en-US", {
    weekday: "long",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: timeZone,
  });
  let [day, time] = localtime.split(" ");
  day = WeekDaysInOrder.indexOf(day) + 1;
  if (time.startsWith("24")) {
    time = `00:${time.split(":")[1]}`;
  }
  for (let hour of businessHours) {
    if (hour.day === day && time >= hour.start && time <= hour.end) {
      return true;
    }
  }
  return false;
}

export function useQuery() {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const res = {};
  for (let pair of params.entries()) {
    res[pair[0]] = pair[1];
  }
  return res;
}

export function getPartySizeOptions(tables) {
  const newTable = tables
    .map((each) => {
      return {
        ...each,
        min: each.min ? Number(each.min) : null,
        max: each.max ? Number(each.max) : null,
      };
    })
    .filter((table) => table.min || table.max);
  return newTable.reduce((pre, cur) => {
    const { min, max } = cur;
    if (min && max) {
      const size = [];
      for (let i = min; i <= max; i++) {
        size.push(String(i));
      }
      return pre.concat(size);
    }
    if (!max) {
      return pre.concat(`${cur.min}+`);
    }
    return pre;
  }, []);
}
